import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const BookIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M21.98 2.02h-6c-1.36 0-2.63.53-3.53 1.5-.15.15-.3.38-.45.53-.15-.23-.3-.38-.45-.53a4.88 4.88 0 0 0-3.53-1.5h-6c-.6 0-1.05.45-1.05.98v15a1 1 0 0 0 .98.98H9A2.05 2.05 0 0 1 11.03 21a1 1 0 0 0 .97.98 1 1 0 0 0 .97-.98A2.05 2.05 0 0 1 15 18.98h6.98a1 1 0 0 0 .97-.98V3c.07-.53-.38-.98-.97-.98ZM11.02 17.55A3.72 3.72 0 0 0 9 17.02H3V3.97h5.02c.83 0 1.58.3 2.1.9.6.6.9 1.35.9 2.1v10.58Zm9.98-.53h-6c-.68 0-1.43.23-2.03.53V7.05c0-.83.3-1.58.9-2.1.6-.6 1.36-.9 2.1-.9H21v12.97Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default BookIcon;
